import React, { useMemo } from 'react'
import { ReactComponent as CalendarDayIcon } from 'assets/CalendarDay.svg'
import { useCSDetailsCachedData } from 'components/configured-service/useCSDetailsCachedData'
import { selectStartDate } from 'data/configured-service/configuredServiceDetailsSelectors'
import T from 'T'
import ServiceDetailChip from 'components/configured-service/layout/ServiceDetailChip'

const ServiceStartDateChip = ({ id, ...props }) => {
  const { data = {} } = useCSDetailsCachedData({ id })
  const startDate = useMemo(() => selectStartDate(data), [data])

  return (
    <ServiceDetailChip
      IconComponent={CalendarDayIcon}
      label={startDate}
      tooltip={T.START_DATE}
      paletteColor="primary"
      paletteVariant="dark"
      {...props}
    />
  )
}

export default ServiceStartDateChip
